import { Card, CardContent } from '@/components/ui/card';
import { FileText, AlertTriangle, Clock, XCircle } from 'lucide-react';

interface ContractStatusCardsProps {
  stats: {
    total: number;
    active: number;
    expiringIn30Days: number;
    expiringIn90Days: number;
    expired: number;
  };
}

export function ContractStatusCards({ stats }: ContractStatusCardsProps) {
  const cards = [
    {
      title: 'Total Active',
      value: stats.active,
      icon: FileText,
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      title: 'Expiring in 30 Days',
      value: stats.expiringIn30Days,
      icon: AlertTriangle,
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
    {
      title: 'Expiring in 90 Days',
      value: stats.expiringIn90Days,
      icon: Clock,
      color: 'text-info',
      bgColor: 'bg-info/10',
    },
    {
      title: 'Expired',
      value: stats.expired,
      icon: XCircle,
      color: 'text-destructive',
      bgColor: 'bg-destructive/10',
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className={`p-3 rounded-lg ${card.bgColor}`}>
                <card.icon className={`h-5 w-5 ${card.color}`} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">{card.title}</p>
                <p className="text-2xl font-bold">{card.value}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
